var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"text-center mb-5",attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('h2',{staticClass:"text-h4 text-md-h2"},[_vm._t("titulo")],2),_c('p',{staticClass:"text-h6 text-md-h4 font-weight-thin font-weight-thin mx-2 mt-2 mt-md-4 mb-0 line-height-125"},[_vm._t("paragrafo")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }